import { HOST } from "../constants/HostConstants";

export const propertyPrefillFromListing = async (propertyId) => {
  const response = await fetch(`${HOST}/api/property/propertyPrefill`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ property_id: propertyId }),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || "Unable to prefill from listing");
  }

  return response.json();
};
